import { HTTPServer } from '@/common/js/ajax'
import * as types from '../mutations-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  initFieldConditions: [],
  allFieldList: [],
  currentBean: null
}

// getters
// const getters = {
//   checkoutStatus: state => state.checkoutStatus,

//   cartProducts: (state, getters, rootState) => {
//     return state.added.map(({ id, quantity }) => {
//       const product = rootState.products.all.find(product => product.id === id)
//       return {
//         title: product.title,
//         price: product.price,
//         quantity
//       }
//     })
//   },
//   cartTotalPrice: (state, getters) => {
//     return getters.cartProducts.reduce((total, product) => {
//       return total + product.price * product.quantity
//     }, 0)
//   }
// }

// actions
const actions = {
  getInitCondition: ({ commit, state }) => {
    HTTPServer.getInitCondition(state.currentBean).then(res => {
      commit('SET_CONDITIONS', res)
    })
  },
  getAllFieldList: ({ commit, state }) => {
    HTTPServer.getAllFieldList(state.currentBean).then(res => {
      let arr = []
      let setchange = function (name) {
        if (name) {
          return name.split('_')[0]
        }
      }
      res.map((v, k) => {
        arr.push({
          label: v.field_label,
          field: v.field_name,
          type: setchange(v.field_name)
        })
      })
      commit('SET_ALL_FIELDS', arr)
    })
  }
}

// mutations
const mutations = {
  [types.SET_CURRENT_BEAN](state, bean) {
    state.currentBean = { bean: bean }
  },
  [types.SET_CONDITIONS](state, data) {
    state.initFieldConditions = data
  },
  [types.SET_ALL_FIELDS](state, data) {
    state.allFieldList = data
  }
}

export default {
  state,
  // getters,
  actions,
  mutations
}
